import './Copyright.css';

const Copyright = () => {
  return (
    <section className='copyright-wrap'>
      <p className='copyright-text'>
        Copyright © 2025 Lancaster
      </p>
      <div className='copyright-links'>
        <a
          className='copyright-text'
          href="https://lancaster.bot/terminos-condiciones"
          target="_blank"
          rel="noreferrer">
          Terminos y Condiciones
        </a>
        <a
          className='copyright-text'
          href="https://lancaster.bot/politica-privacidad"
          target="_blank"
          rel="noreferrer">
          Política de Privacidad
        </a>
      </div>
    </section>
  );
};

export default Copyright;
